import { include } from '../../doc/app/App';

include({
    name: 'InboxWidget',
    doc: require('./doc.md'),
    examples: [
        {
            name: 'Example',
            import: require('./example.src'),
        },
    ],
});
